import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncMessagesPage = Load(
  () => import(/* webpackChunkName: "chat2" */ './components/MessagesPage'),
);
const AsyncSchedulePage = Load(
  () => import(/* webpackChunkName: "chat2" */ './components/SchedulePage'),
);
const AsyncArchivedBookingsPage = Load(
  () =>
    import(/* webpackChunkName: "chat2" */ './components/ArchivedBookingsPage'),
);
const AsyncActionPage = Load(
  () => import(/* webpackChunkName: "chat2" */ './components/ActionPage'),
);
const AsyncBookingDetailsPage = Load(
  () =>
    import(/* webpackChunkName: "chat2" */ './components/BookingDetailsPage'),
);

export const messagesRoute: RouteDescriptor = {
  id: 'user-env.messages',
  path: `${basePath}/messages/*`,
  label: 'Messages',
  audience: 'both',
  layout: 'navigational',
  module: 'user-environment2',
};

export const actionRoute: RouteDescriptor = {
  id: 'user-env.action',
  path: `${basePath}/action/*`,
  label: 'Action Center',
  audience: 'both',
  layout: 'navigational',
  module: 'user-environment2',
};

export const scheduleRoute: RouteDescriptor = {
  id: 'user-env.schedule',
  path: `${basePath}/schedule/*`,
  label: 'Schedule',
  audience: 'both',
  layout: 'navigational',
  module: 'user-environment2',
};

export const archivedBookingsRoute: RouteDescriptor = {
  id: 'user-env.archived-bookings',
  path: `${basePath}/archived-bookings/*`,
  label: 'Archived Bookings',
  audience: 'both',
  layout: 'navigational',
  module: 'user-environment2',
};

export const bookingDetailsRoute: RouteDescriptor = {
  id: 'user-env.booking-details',
  path: `${basePath}/booking-details/:bookingId/`,
  label: 'Booking Details',
  audience: 'both',
  layout: 'standalone',
  module: 'user-environment2',
};

const isApp = isCordova();

export const userEnvironmentRoutes = [
  createNavigationalRoute({
    key: messagesRoute.id,
    id: messagesRoute.id,
    path: messagesRoute.path,
    handle: createRouteHandle(messagesRoute),
    hideFooter: true,
    showBottomNavigation: true,
    noNavbar: isApp,
    component: AsyncMessagesPage,
    showZendesk: false,
  }),
  createNavigationalRoute({
    key: actionRoute.id,
    id: actionRoute.id,
    path: actionRoute.path,
    handle: createRouteHandle(actionRoute),
    hideFooter: true,
    showBottomNavigation: true,
    noNavbar: isApp,
    component: AsyncActionPage,
    showZendesk: false,
  }),
  createNavigationalRoute({
    key: scheduleRoute.id,
    id: scheduleRoute.id,
    path: scheduleRoute.path,
    handle: createRouteHandle(scheduleRoute),
    hideFooter: true,
    showBottomNavigation: true,
    noNavbar: isApp,
    component: AsyncSchedulePage,
    showZendesk: false,
  }),
  createNavigationalRoute({
    key: archivedBookingsRoute.id,
    id: archivedBookingsRoute.id,
    path: archivedBookingsRoute.path,
    handle: createRouteHandle(archivedBookingsRoute),
    hideFooter: true,
    showBottomNavigation: true,
    noNavbar: isApp,
    component: AsyncArchivedBookingsPage,
    showZendesk: false,
  }),
  createNavigationalRoute({
    key: bookingDetailsRoute.id,
    id: bookingDetailsRoute.id,
    path: bookingDetailsRoute.path,
    handle: createRouteHandle(bookingDetailsRoute),
    hideFooter: true,
    showBottomNavigation: true,
    noNavbar: isApp,
    component: AsyncBookingDetailsPage,
    showZendesk: false,
  }),
];

export const userEnvironmentRouteDescriptors = [
  messagesRoute,
  actionRoute,
  scheduleRoute,
  archivedBookingsRoute,
  bookingDetailsRoute,
];

export default userEnvironmentRoutes;
